import axios from "axios";

const api = axios.create({
  // baseURL:'http://localhost:3000/api',
  baseURL: process.env.REACT_APP_FROT_API_URL || "https://api-core-comunicacao-git-631554619185.europe-west1.run.app/api",
  timeout: 20000,
});

export async function getFreights(params = {}) {
  // params opcional (futuro): page, limit, status, dateStart, dateEnd, etc.
  console.log("getFreights params:", params);

  const response = await api.get("/freight", { params });

  const payload = response?.data;

  // garante formato esperado
  if (!payload || payload.success !== true) {
    const msg = payload?.message || "Falha ao buscar fretes.";
    throw new Error(msg);
  }

  // retorna tudo caso você queira usar count/message também
  // payload = { success, data, message, count }
  return payload;
}
